import {Box, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import LabelInput from '../../customTable/LabelInput'
import Tabs from '../../customTable/Tabs'
import InputType from '../../customTable/InputType'
import RedStart from '../../customTable/RedStart'
import Card from './Card'
import SeoApi from '../../../Api/Seo'
import RestSaveButton from '../../customTable/RestSaveBtns'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import TabsWithFlag from '../../customTable/LangTabsWithFlag'
import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'
import Loading from '../../customTable/LoadingForm'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, {AlertProps} from '@mui/material/Alert'
import MainBtn from '../../customTable/MainBtn'
import {Stack} from '@mui/material'
import TextErea from '../../customTable/TextErea'
import Label from '../../customTable/Label'
import SeoOne from '../../../svg/SeoOne'
import SeoTwo from '../../../svg/SeoTwo'
import SeoThree from '../../../svg/SeoThree'
import SeoFour from '../../../svg/SeoFour'
import SeoFive from '../../../svg/SeoFive'
import SeoSix from '../../../svg/SeoSix'
import SeoSiven from '../../../svg/SeoSiven'
import SeoNighan from '../../../svg/SeoNighan'
import SeoLabelWithIcon from './SeoLabelWithIcon'
import SeoNike from '../../../svg/SeoNike'
import SeoTen from '../../../svg/SeoTen'
import IncludesSeo from '../../../svg/IncludesSeo'
import ExCludes from '../../../svg/ExCludes'
import MaxCharactersNote from '../../customTable/MaxCharactersNote'
import ValidationFun from '../../../yup/ValidationFun'
import {SeoSchema} from '../../../yup/SettingSchema'
import NoNetWork from '../../customTable/NoNetWork'

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
})
export default function Seo() {
  const [setting, setSetting] = useState<any>({})
  const [open, setOpen] = React.useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingSeo, setIsLoadingSeo] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const getSeo = async () => {
    SeoApi.get((res: any) => {
      setSetting(res.data)
      setOld(res.data)
    }, setIsLoadingSeo)
  }
  const [old, setOld] = useState({})

  const handelSubmit = () => {
    ValidationFun(setting, SeoSchema, setErrors, () => {})
    SeoApi.put(
      setting,
      (res: any) => {
        setOld(res)
      },
      setIsLoading
    )
  }
  const store = useSelector((state: RootState) => state.vender)
  const {t} = useTranslation()

  const [defLang, setDefLang] = useState('')
  const [selectedLang, setSelectedLang] = useState<any>([])
  const getLangs = async () => {
    setSelectedLang(store.langs)
    setDefLang(
      store.langs.some((e: any) => e.code === store.defLang) ? store.defLang : store.langs[0].code
    )
  }
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }
  const copyLink = () => {
    navigator.clipboard
      .writeText(setting.sitemap)
      .then(() => {
        setOpen(true)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    getLangs()
  }, [store.langs])
  useEffect(() => {
    getSeo()
  }, [])
  const seoData = [
    // {icon: <SeoOne />, text: 'yourSeoFilesAreAutoManaged'},
    // {
    //   icon: <SeoTwo />,
    //   text: 'lastUpdated',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='2024-04-10 14:35' />,
    // },
    // {
    //   icon: <SeoThree />,
    //   text: 'products',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='125' />,
    // },
    // {
    //   icon: <SeoFive />,

    //   text: 'categories',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='125' />,
    // },

    // {
    //   icon: <SeoFour />,

    //   text: 'CMSPages',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='125' />,
    // },
    // {
    //   icon: <SeoNike />,
    //   text: 'sitemap',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='Active' />,
    // },
    // {
    //   icon: <SeoFour />,

    //   text: 'viewSitemap.xml',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='125' />,
    // },
    {
      icon: <SeoSix />,
      text: 'viewSitemap.xml',
      value: (
        <Stack direction={'row'} sx={{color: '#5E6278', fontSize: '14px'}}>
          ({' '}
          <Stack sx={{cursor: 'pointer', fontSize: '14px'}} color='#009EF7'>
            {store.sizeImages && store.sizeImages.seo && store.sizeImages.seo.sitemap}
          </Stack>{' '}
          )
        </Stack>
      ),
    },

    // {
    //   icon: <SeoSiven />,
    //   text: 'robots.txt',
    //   value: <Label fw='400' fs='14px' color='#5E6278' text='Standard rules' />,
    // },
    // {icon: <SeoNighan />, text: 'viewRobots.txt'},
    {
      icon: <SeoSix />,
      text: 'viewRobots',
      value: (
        <Stack direction={'row'} sx={{color: '#5E6278', fontSize: '14px'}}>
          ({' '}
          <Stack direction={'row'} sx={{cursor: 'pointer', fontSize: '14px'}} color='#009EF7'>
            {store.sizeImages && store.sizeImages.seo && store.sizeImages.seo.robots}
          </Stack>{' '}
          )
        </Stack>
      ),
    },

    // {icon: <SeoTen />, text: 'yourStoreFollowsSEOBestPractices.NoActionIsNeeded'},
  ]
  return (
    <NoNetWork>
      {' '}
      <>
        {isLoadingSeo ? (
          <Stack position={'relative'} minHeight={'80vh'} width={'100%'}>
            <Loading />
          </Stack>
        ) : (
          <Stack>
            <Stack
              p='24px'
              borderRadius={'8px'}
              bgcolor={'var(--bs-app-header-base-bg-color)'}
              width={'100%'}
            >
              <Stack
                gap='15px'
                flexWrap={'wrap'}
                direction={'row'}
                justifyContent={'space-between'}
              >
                <Typography
                  sx={{
                    fontSize: '17.5px',
                    color: 'var(--bs-heading-color, inherit)',
                    fontWeight: 600,
                    lineHeight: '16px',
                    textTransform: 'capitalize',
                  }}
                >
                  {t('seo')}{' '}
                </Typography>{' '}
                <TabsWithFlag
                  languages={selectedLang}
                  // msgErr={msgErr}
                  activeLang={defLang}
                  setActiveLang={setDefLang}
                />
              </Stack>
              <Stack gap='20px' mt='24px'>
                <Stack>
                  {selectedLang.map((e: any, i: number) => (
                    <>
                      {e.code === defLang && (
                        <Stack gap='20px' flexWrap={'wrap'} direction={'row'}>
                          <Stack width={{sm: '48%', xs: '100%'}} gap='10px'>
                            <label style={{display: 'flex', gap: '5px'}} htmlFor={e.code}>
                              <LabelInput text={t('keyword')} />
                            </label>
                            <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                              <InputType
                                characters={100}
                                name={'home_meta_keywords'}
                                change={setSetting}
                                value={setting}
                                type='text'
                                child={e.code}
                              />
                              {/* <ErrorMsg msgErr={msgErr} name='title' /> */}
                            </Box>
                          </Stack>
                          <Stack width={{sm: '48%', xs: '100%'}} gap='10px'>
                            <label style={{display: 'flex', gap: '5px'}} htmlFor={e.code}>
                              <LabelInput text={t('metaTitle')} />
                            </label>
                            <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                              <InputType
                                characters={70}
                                name={'home_meta_title'}
                                change={setSetting}
                                value={setting}
                                type='text'
                                child={e.code}
                              />
                              {/* <ErrorMsg msgErr={msgErr} name='title' /> */}
                            </Box>
                          </Stack>
                          <Stack width={{xs: '100%'}} gap='10px'>
                            <label style={{display: 'flex', gap: '5px'}} htmlFor={e.code}>
                              <LabelInput text={t('metaDescription')} />
                            </label>
                            <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                              <TextErea
                                name={'home_meta_description'}
                                change={setSetting}
                                value={setting}
                                child={e.code}
                              />
                              {<MaxCharactersNote characters={160} />}

                              {/* <ErrorMsg msgErr={msgErr} name='title' /> */}
                            </Box>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  ))}
                </Stack>
              </Stack>
            </Stack>
            <Stack mt='24px'>
              <Card
                setting={setting}
                setSetting={setSetting}
                name='facebook_pixel'
                title={t('googleTags')}
                subTitle='googleTags'
                characters={255}
              />
            </Stack>
            <Stack mt='24px'>
              <Card
                setting={setting}
                setSetting={setSetting}
                name='google_tags'
                title='facebook pixel'
                subTitle='facebookPixel'
                characters={255}
              />
            </Stack>
            <Stack
              mt='24px'
              p='24px'
              borderRadius={'8px'}
              bgcolor={'var(--bs-app-header-base-bg-color)'}
              width={'100%'}
            >
              <Label fw='600' fs='16px' text='seoAutomationStatus' />
              <Stack mt='24px' gap='24px'>
                {seoData.map((e: any) => (
                  <SeoLabelWithIcon item={e} />
                ))}
              </Stack>
            </Stack>
            <Stack
              mt='24px'
              p='24px'
              borderRadius={'8px'}
              gap='24px'
              bgcolor={'var(--bs-app-header-base-bg-color)'}
              width={'100%'}
            >
              <Label fw='600' fs='16px' text='robots.txtRules' />
              <Stack alignItems={'center'} gap='5px' direction={'row'}>
                <Label
                  fs='14px'
                  color='#5E6278'
                  text='youCanEditYourRobots.txtFileToRestrictSearchEngineAccessToCertainPagesInYourStore.'
                />
              </Stack>
              <Stack width={{xs: '100%'}} gap='10px'>
                <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                  <TextErea name={' robot_txt'} change={setSetting} value={setting} />
                  {<MaxCharactersNote characters={2000} />}

                  {/* <ErrorMsg msgErr={msgErr} name='title' /> */}
                </Box>
                <Stack alignItems={'flex-end'}>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              {store.permissions &&
                store.permissions &&
                store.permissions.includes('seo_update') && (
                  <RestSaveButton
                    isLoading={isLoading}
                    SaveText='Save'
                    cancelText='Rest'
                    submit={handelSubmit}
                    cancel={() => setSetting(old)}
                  />
                )}
            </Stack>
          </Stack>
        )}
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='success' sx={{width: '100%'}}>
            {t('msgSuccessfully')}
          </Alert>
        </Snackbar>
      </>
    </NoNetWork>
  )
}
